var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3794_7649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3324 13.9065H6.76914C5.63867 13.9065 4.66953 13.0999 4.46445 11.9881L2.62383 2.17192C2.54414 1.81839 2.225 1.56253 1.86172 1.56253H0.78125C0.349609 1.56253 0 1.21291 0 0.781265C0 0.349616 0.349609 0 0.78125 0H1.86172C2.95937 0 3.92344 0.779312 4.15352 1.85277C4.15508 1.85941 4.15625 1.86605 4.15742 1.8723L4.36289 2.96881H19.2184C19.6992 2.96881 20.0688 3.40085 19.9891 3.87859L18.6441 11.9479C18.4551 13.0827 17.4828 13.9065 16.3324 13.9065ZM4.65586 4.53134L6.00039 11.7022C6.06914 12.0748 6.39219 12.344 6.76914 12.344H16.3324C16.716 12.344 17.0398 12.0694 17.1031 11.6912L18.2965 4.53134H4.65586Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30124 10.1418L6.7239 7.01674C6.53601 6.00109 8.07234 5.71554 8.26023 6.73275L8.83757 9.85781C9.02546 10.8738 7.48914 11.1598 7.30124 10.1418Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2385 9.87179L14.7596 6.74673C14.9295 5.72796 16.4709 5.98343 16.3006 7.00377L15.7795 10.1288C15.6065 11.166 14.0698 10.8839 14.2385 9.87179Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 20.0001C5.58281 20.0001 4.53125 18.9485 4.53125 17.6563C4.53125 16.3641 5.58281 15.3125 6.875 15.3125C8.16719 15.3125 9.21875 16.3641 9.21875 17.6563C9.21875 18.9485 8.16719 20.0001 6.875 20.0001Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 20.0001C14.9578 20.0001 13.9062 18.9485 13.9062 17.6563C13.9062 16.3641 14.9578 15.3125 16.25 15.3125C17.5422 15.3125 18.5938 16.3641 18.5938 17.6563C18.5938 18.9485 17.5422 20.0001 16.25 20.0001Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 9.99988V6.87482C10.7812 5.84199 12.3438 5.84042 12.3438 6.87482V9.99988C12.3438 11.0327 10.7812 11.0343 10.7812 9.99988Z",
    fill: "#2060EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3794_7649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/ordersIcon.938e600f0970c42352435b6f507de609.svg";
export { ForwardRef as ReactComponent };